var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded bg-gray-800 py-1 flex-col mb-3 ml-1"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }